// extracted by mini-css-extract-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1__a641a7e85fe2c67750b8","cls2":"UserTaggingPingBodyStyles-cls2___215be13ee9ea983deaf UserTaggingPingBodyStyles-cls1__a641a7e85fe2c67750b8"};